import { IGroupformData } from './interfaces'

export const defaultFormData: IGroupformData = {
    name: '',
    description: '',
    accessRestrictions: {
        templateId: '',
        attributes: [
            {
                attributeId: '',
                records: [],
            },
        ],
        includeEmptyRecords: false,
    },
}
